import { useTranslation } from 'react-i18next';

import type { VirtuousIntegration } from '@feathr/blackbox';
import type { IIntegrationUIOption } from '@feathr/components';
import { useLazyOptions } from '@feathr/extender/App/Settings/Account/RaisersEdgeIntegrationPageV2/useLazyOptions';

/** The Virtuous projects a donation can go to, loaded the first time `enabled` is true. */
export function useVirtuousProjectOptions(
  integration: VirtuousIntegration,
  enabled: boolean,
): readonly IIntegrationUIOption[] | undefined {
  const { t } = useTranslation();

  return useLazyOptions({
    enabled,
    errorLabel: (error) => t('Failed to load projects:\n{{- error}}', { error }),
    load: () => integration.getProjects(),
  });
}

/** The Virtuous Contact Note types, loaded the first time `enabled` is true. */
export function useVirtuousNoteTypeOptions(
  integration: VirtuousIntegration,
  enabled: boolean,
): readonly IIntegrationUIOption[] | undefined {
  const { t } = useTranslation();

  return useLazyOptions({
    enabled,
    errorLabel: (error) => t('Failed to load note types:\n{{- error}}', { error }),
    load: () => integration.getNoteTypes(),
  });
}
